export default {
  title: 'Kalkulator przychodów z opłaty serwisowej',
  description: 'Oszacuj miesięczny przychód z opłaty serwisowej. Wartości aktualizują się podczas wpisywania.',
  authoritative:
    'Procent i maksymalna opłata poniżej to ustawienia, które zostaną zastosowane. Średnia wartość zamówienia i miesięczne GMV to tylko szacunki.',
  off_notice:
    'Opłata serwisowa jest wyłączona w tej restauracji, więc na razie nic nie zarabia. Zapisz opłatę powyżej, aby ją włączyć.',
  fields: {
    recommended: 'Zalecane: {{value}}',
    aov: {
      label: 'Średnia wartość zamówienia',
      help: 'Typowa wielkość koszyka w Twoim systemie zamówień online.',
      placeholder: 'np. 32,50',
    },
    percentage: {
      label: 'Procent opłaty serwisowej',
      help: 'Od {{min}}% do {{max}}%.',
    },
    max_amount: {
      label: 'Maksymalna opłata za zamówienie',
      help: '{{max}} to maksimum platformy.',
      below_min: 'Maksymalna opłata musi wynosić co najmniej {{min}}.',
    },
    monthly_gmv: {
      label: 'Miesięczne GMV',
      help: 'Całkowita wartość zamówień przetworzonych w miesiącu.',
      placeholder: 'np. 85000',
    },
  },
  outputs: {
    partner_revenue: 'Twój szacowany miesięczny przychód',
    approximate: 'Wartość przybliżona na podstawie powyższych danych — rzeczywisty przychód może się różnić.',
    estimate_inputs: 'Na podstawie szacowanej wartości zamówienia i GMV — rzeczywisty przychód może się różnić.',
    share: 'To Twój udział {{share}}% w całkowitej opłacie serwisowej pobranej od gości.',
    total_collected: 'Całkowita opłata serwisowa pobrana od gości przy płatności',
    total_collected_note: '— płacona przez gości, nie dodatkowy przychód ponad powyższą kwotę.',
    effective_rate: 'Efektywna stawka opłaty dla wszystkich zamówień',
  },
};
